// extracted by mini-css-extract-plugin
module.exports = {"products__nav":"ProductsNav_products__nav__1Ptjj","products__nav__item":"ProductsNav_products__nav__item__3EYoR","active":"ProductsNav_active__1x3wF"};